<template>
  <MTab v-model="currentTab" position="left">
    <MTabPane
      key="quantity_details"
      :tab="`${$tc('quantity')} ${$tc('details', 2)}`"
    >
      <QuantityList
        :resource-id="resourceId"
        :resource="resource"
        :disabled="disabled"
        @refresh="$emit('refresh', $event)"
      />
    </MTabPane>
    <MTabPane
      v-if="totalCustomFields.length"
      key="custom_fields"
      :tab="$tc('custom_fields')"
    >
      <CustomFieldTab
        :asset="asset"
        :custom-fields-for-all="customFieldsForAll"
        :selected-asset-types="selectedAssetTypes"
        :custom-field-for-asset-type="availableCustomFieldForAssetType"
        :asset-type-id="resource.assetTypeId"
        :update-api="updateApi"
        :disabled="disabled"
        @change="handleFieldValueChange"
      />
    </MTabPane>
  </MTab>
</template>

<script>
import CloneDeep from 'lodash/cloneDeep'
import { FormComputed } from '@state/modules/form'
import { AssetTypeComputed } from '@state/modules/asset-type'
import { findValuePathWithItems } from '@data/recursive'
import {
  customFieldsForAllAssetType,
  customFieldAttributesTypePrefix,
  customFieldForAssetType,
  customFieldAttributesModuleName,
} from '@modules/asset/helpers/asset-custom-fields'
import CustomFieldTab from './property/custom-field-tab'
import QuantityList from './quantity-container/quantity-list.vue'
export default {
  name: 'ConsumablePropertyTab',
  components: { CustomFieldTab, QuantityList },
  props: {
    resourceId: { type: Number, required: true },
    resource: { type: Object, required: true },
    updateApi: { type: Function, required: true },
    moduleName: { type: String, required: true },
    disabled: { type: Boolean, default: false },
  },
  data() {
    return {
      asset: CloneDeep(this.resource),
      loading: true,
      currentTab: 'quantity_details',
    }
  },
  computed: {
    // @TODO refector custom field tab for asset
    ...FormComputed,
    ...AssetTypeComputed,
    customFields() {
      const typePrefix = customFieldAttributesTypePrefix(this.moduleName)
      return (
        ((this.assetForm || {}).fields || []).filter(
          (f) =>
            f.attributes.model ===
              customFieldAttributesModuleName(this.moduleName) &&
            !f.attributes[`${typePrefix}PropertyType`] &&
            !f.attributes[`${typePrefix}ComponentType`]
        ) || []
      )
    },
    selectedAssetTypes() {
      const typePrefix = customFieldAttributesTypePrefix(this.moduleName)
      if (this.asset[`${typePrefix}TypeId`]) {
        const collection = this[`${typePrefix}Types`]
        const assetTypeId = this.asset[`${typePrefix}TypeId`]
        const path = findValuePathWithItems(collection, assetTypeId)
        const rootItem = path[0]
        return {
          list: path,
          ...rootItem,
        }
      }
      return {}
    },
    customFieldsForAll() {
      return customFieldsForAllAssetType(this.customFields, this.moduleName)
    },
    availableCustomFieldForAssetType() {
      const typePrefix = customFieldAttributesTypePrefix(this.moduleName)
      if (!this.asset[`${typePrefix}TypeId`]) {
        return {}
      }
      const fullPath = this.selectedAssetTypes.list
      const assetTypeFields = {}
      fullPath.forEach((p) => {
        assetTypeFields[p.id] = customFieldForAssetType(
          this.moduleName,
          this.customFields,
          [p.id]
        )
      })
      return assetTypeFields
    },
    totalCustomFields() {
      const assetTypeFields = this.availableCustomFieldForAssetType
      let f = []
      Object.keys(assetTypeFields).map((i) => {
        f = f.concat(assetTypeFields[i])
      })
      return [...f, ...this.customFieldsForAll]
    },
  },
  methods: {
    handleFieldValueChange(c) {
      this.asset = {
        ...this.asset,
        ...c,
        fieldValueDetails: {
          ...this.asset.fieldValueDetails,
          ...c,
        },
      }
    },
  },
}
</script>
